import { Navigate } from "react-router-dom";
import localKey from '../storage/localKey';

export const ProtectedRoute = ({ children }) => {
  // const { user } = useAuth();
  let token = localStorage.getItem(localKey.AUTH_TOKEN);
  if (!token) {
    // user is not authenticated
    return <Navigate to="/login" />;
  }
  return children;
};